import React from 'react';
// import './OffersSection.css'; // Import CSS for styles

const OffersSection = ({ offers }) => {
    return (
        <div className="homepage-offets-sec-middlePart d-flex flex-column">
            {/* Title Row */}
            <div className="d-flex flex-row px-4" style={{ justifyContent: 'space-between' }}>
                <p className="card-title-middle1">Offers</p>
            </div>

            {/* Offers Row */}
            <div
                className="d-flex flex-row offers-container"
                style={{
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                }}
            >
                {offers.map((offer, index) => (
                    <img
                        key={index}
                        src={offer.image}
                        className="offer-image mx-3 mb-2"
                        alt={offer.alt || 'Offer image'}
                    />
                ))}
            </div>
        </div>
    );
};

export default OffersSection;
